// extracted by mini-css-extract-plugin
module.exports = {"MenuItem":"MenuItem_MenuItem__38YyF","rendered":"MenuItem_rendered__sJk-5"};